{
	"pixKeyLabel": "Clé PIX",
	"pixTypeLabel": "Type de clé Pix",
	"pixTypePlaceholder": "Sélectionner le type de clé Pix",
	"pixKeyType": {
		"random": "Aléatoire",
		"phone": "Téléphone",
		"copyPaste": "Copier et coller"
	},
	"validation": {
		"invalidPixKey": "Clé pix invalide"
	}
}
